import User from "@views/user/User";

export default [
  {
    path: "/user",
    name: "User",
    meta: {
      title: "个人中心",
      keepAlive: true,
      footer: true,
      auth: true
    },
    component: User
  },
  {
    path: "/user/binding",
    name: "BindingPhone",
    meta: {
      title: "绑定手机",
      keepAlive: true,
      backgroundColor: "#fff",
      auth: true
    },
    component: () => import("@views/user/BindingPhone.vue")
  },
  {
    path: "/user/add_address/:id?",
    name: "AddAddress",
    meta: {
      title: "添加收货地址",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/address/AddAddress.vue")
  },
  {
    path: "/user/account",
    name: "UserAccount",
    meta: {
      title: "我的账户",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserAccount.vue")
  },
  {
    path: "/user/add_manage",
    name: "AddressManagement",
    meta: {
      title: "地址管理",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/address/AddressManagement.vue")
  },
  {
    path: "/user/poster",
    name: "Poster",
    meta: {
      title: "我的海报",
      keepAlive: false,
      backgroundColor: "#a3a3a3",
      auth: true
    },
    component: () => import("@views/user/promotion/Poster.vue")
  },
  {
    path: "/user/sign",
    name: "Sign",
    meta: {
      title: "签到",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/signIn/Sign.vue")
  },
  {
    path: "/user/sign_record",
    name: "SignRecord",
    meta: {
      title: "签到记录",
      keepAlive: true
    },
    component: () => import("@views/user/signIn/SignRecord.vue")
  },
  {
    path: "/user/cash",
    name: "UserCash",
    meta: {
      title: "提现",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/UserCash.vue")
  },
  {
    path: "/user/audit",
    name: "CashAudit",
    meta: {
      title: "提现审核",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CashAudit.vue")
  },

  {
    path: "/user/promoter_order",
    name: "PromoterOrder",
    meta: {
      title: "推广人订单",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterOrder.vue")
  },
  {
    path: "/user/promoter_list",
    name: "PromoterList",
    meta: {
      title: "推广人列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterList.vue")
  },
  {
    path: "/user/user_promotion",
    name: "UserPromotion",
    meta: {
      title: "我的推广",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/UserPromotion.vue")
  },
  {
    path: "/user/bill/:types?",
    name: "UserBill",
    meta: {
      title: "账单明细",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserBill.vue")
  },
  {
    path: "/user/cashrecord",
    name: "CashRecord",
    meta: {
      title: "提现记录",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CashRecord.vue")
  },
  {
    path: "/user/commission/:add_day",
    name: "CommissionDetails",
    meta: {
      title: "佣金明细",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CommissionDetails.vue")
  },
  {
      path: "/user/commission_day/:add_month",
          name: "CommissionDetailsDay",
      meta: {
      title: "日度佣金",
          keepAlive: true,
          auth: true
  },
      component: () => import("@views/user/promotion/CommissionDetailsDay.vue")
  },
{
    path: "/user/commission_month",
        name: "CommissionDetailsMonth",
    meta: {
    title: "月度佣金",
        keepAlive: true,
        auth: true
},
    component: () => import("@views/user/promotion/CommissionDetailsMonth.vue")
},
    {
        path: "/user/income/:add_day",
            name: "Income",
        meta: {
        title: "业绩明细",
            keepAlive: true,
            auth: true
    },
        component: () => import("@views/user/promotion/Income.vue")
    },
    {
        path: "/user/income_day/:add_month",
            name: "IncomeDay",
        meta: {
        title: "日度业绩",
            keepAlive: true,
            auth: true
    },
        component: () => import("@views/user/promotion/IncomeDay.vue")
    },
{
    path: "/user/income_month",
        name: "IncomeMonth",
    meta: {
    title: "月度业绩",
        keepAlive: true,
        auth: true
},
    component: () => import("@views/user/promotion/IncomeMonth.vue")
},
  {
    path: "/user/integral",
    name: "Integral",
    meta: {
      title: "积分详情",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/signIn/Integral.vue")
  },
  {
    path: "/user/vip",
    name: "UserVip",
    meta: {
      title: "会员中心",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserVip.vue")
  },
  {
    path: "/user/data",
    name: "PersonalData",
    meta: {
      title: "个人资料",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/PersonalData.vue")
  },
  {
    path: "/user/user_coupon",
    name: "UserCoupon",
    meta: {
      title: "我的优惠券",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/coupon/UserCoupon.vue")
  },
  {
    path: "/user/get_coupon",
    name: "GetCoupon",
    meta: {
      title: "领取优惠券",
      keepAlive: true
    },
    component: () => import("@views/user/coupon/GetCoupon.vue")
  },
  {
    path: "/user/user_cash",
        name: "UserCash",
        meta: {
        title: "申请提现",
            keepAlive: true,
            auth: true
    },
    component: () => import("@views/user/promotion/UserCash.vue")
},
{
    path: "/user/transfer",
        name: "Transfer",
    meta: {
    title: "账户转账",
        keepAlive: true,
        auth: true
},
    component: () => import("@views/user/promotion/Transfer.vue")
},

    {
        path: "/user/transferAudit",
        name: "transferAudit",
        meta: {
            title: "转账成功提示",
            keepAlive: true,
            auth: true
        },
        component: () => import("@views/user/promotion/TransferAudit.vue")
    },
    {
        path: "/user/transfercord",
        name: "transfercord",
        meta: {
            title: "转账记录",
            keepAlive: true,
            auth: true
        },
        component: () => import("@views/user/promotion/TransferRecord.vue")
    },

  {
    path: "/customer/list/:productId?",
    name: "CustomerList",
    meta: {
      title: "客服列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/CustomerList.vue")
  },
  {
    path: "/user/Recharge/:goods_area?/:level?",
    name: "Recharge",
    meta: {
      title: "余额充值",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/Recharge.vue")
  },
  {
    path: "/user/promoter_rank",
    name: "PromoterRank",
    meta: {
      title: "推广人排行",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterRank.vue")
  },
  {
    path: "/user/commission/rank",
    name: "CommissionRank",
    meta: {
      title: "佣金排行",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CommissionRank.vue")
  },
  {
      path: "/user/recharge_list/:types?",
          name: "RechargeList",
          meta: {
              title: "充值记录",
              keepAlive: true,
              auth: true
          },
      component: () => import("@views/user/RechargeList.vue")
  },
  {
      path: "/user/recharge_list_next/:types?",
          name: "RechargeListNext",
      meta: {
      title: "下级充值",
          keepAlive: true,
          auth: true
  },
      component: () => import("@views/user/RechargeListNext.vue")
  }


];
